export const downloadViaLinkCreated = function (url) {
  const downloadLink = document.createElement("a");
  downloadLink.setAttribute("href", url);
  downloadLink.setAttribute("style", "display:none");
  downloadLink.setAttribute("target", "_blank");
  document.body.append(downloadLink);

  setTimeout(function () {
    downloadLink.click();
    downloadLink.remove();
  }, null);
};
